import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { StockImagePanelContent } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { useSourceImages } from './hooks/use-source-images';
import { AdsStudioAddAssetPanel } from './add-asset-panel';

export const StockImagePanel = (props) => {
  const {
    i18n,
    aid, cid, oDataConfig,
    dataService, logger, notificationApi, navigation, open, perfMarker,
  } = props;
  const {
    setSelectedImages, onStockClickSelect, showBlocker, selectedImages,
  } = useSourceImages({
    dataService, logger, navigation, perfMarker,
  });

  const dismiss = useCallback(() => {
    navigation.goBack();
  }, [navigation]);

  return (
    <AdsStudioAddAssetPanel
      aid={aid}
      i18n={i18n}
      dismiss={dismiss}
      isOpen={open}
      showBlocker={showBlocker}
      selectedAsset={selectedImages}
      headerText={i18n.getString(_TL_('Shutterstock images'))}
      logger={logger}
      notificationApi={notificationApi}
      onClickSelect={onStockClickSelect}
    >
      <StockImagePanelContent i18n={i18n} aid={aid} cid={cid} oDataConfig={oDataConfig} setSelectedImages={setSelectedImages} />
    </AdsStudioAddAssetPanel>
  );
};

StockImagePanel.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  navigation: PropTypes.shape({ gotoImagesPage: PropTypes.func }).isRequired,
  dataService: PropTypes.shape({
    uploadImage: PropTypes.func,
    uploadStockImage: PropTypes.func,
    uploadImageByUrl: PropTypes.func,
  }).isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
  aid: PropTypes.number.isRequired,
  cid: PropTypes.number.isRequired,
  oDataConfig: PropTypes.shape({}).isRequired,
  notificationApi: PropTypes.shape({
    showWarning: PropTypes.func,
  }).isRequired,
  open: PropTypes.bool.isRequired,
};
